import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { utilFormatPhoneNumber } from '@/fo/util/format-phone-number';

import { PointFeature } from '../../types';

import { styles } from './PickupPointInfo.styles';

export interface PickupPointInfoProps {
  point: PointFeature;
  activePointId: string | null;
  onPointConfirm: (pointId: string) => void;
  hideConfirmButton?: boolean;
  isFreeShipping?: boolean;
}

export function PickupPointInfo({
  point,
  activePointId,
  onPointConfirm,
  hideConfirmButton,
  isFreeShipping
}: PickupPointInfoProps) {
  const t = useTranslations();

  const slots = styles();

  if (!('pointType' in point.properties)) {
    return (
      <>
        <div className={slots.pointTitle()}>{point.properties.title}</div>
        <div className={slots.pointAddress()}>{point.properties.street}</div>
      </>
    );
  }

  return (
    <>
      <div className={slots.pointTitle()}>
        {!!point.properties.pointPrefix && (
          <span className={slots.pointPrefix()}>
            {point.properties.pointPrefix}{' '}
          </span>
        )}
        {point.properties.pointType}
      </div>
      <div className={slots.pointAddress()}>{point.properties.street}</div>
      <div className={slots.pointCost()}>
        {t('cost')}: {isFreeShipping ? t('Free') : `${point.properties.cost} ₽`}
      </div>
      {point.properties.dayFrom && (
        <div className={slots.pointDeliveryDate()}>
          {t('deliveryDate')}:{' '}
          {(() => {
            const today = new Date();
            const targetDate = new Date(today);
            targetDate.setDate(
              today.getDate() + Number(point.properties.dayTo)
            );
            const dateStr = targetDate.toLocaleDateString('ru-RU', {
              day: 'numeric',
              month: 'long'
            });
            const weekdayStr = targetDate.toLocaleDateString('ru-RU', {
              weekday: 'long'
            });
            return `${dateStr}, ${weekdayStr}`;
          })()}
        </div>
      )}
      {activePointId === point.id && (
        <>
          <div className={slots.pointHeading()}>{t('openingHours')}</div>
          <div className={slots.pointValue()}>
            {point.properties.openingHours.map((hour, index) => (
              <div key={index}>{hour}</div>
            ))}
          </div>
          <div className={slots.pointHeading()}>{t('phone')}</div>
          <div className={slots.pointValue()}>
            {utilFormatPhoneNumber(point.properties.phone)}
          </div>
          {!hideConfirmButton && (
            <div className={slots.pointConfirm()}>
              <UiKitButtonBase onClick={() => onPointConfirm(point.id)}>
                {t('deliverHere')}
              </UiKitButtonBase>
            </div>
          )}
        </>
      )}
    </>
  );
}
